module.exports = __webpack_public_path__ + "static/media/howitworks-group.fdfc16aa.webp";